// @ constants
const actionTypes = require('constants/actionTypes');
const {
    PERIODIC_LOADS_MIN_AMOUNT_DEFAULT,
    PERIODIC_LOADS_MAX_AMOUNT_DEFAULT
} = require('constants/cardPeriodicLoads');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

const getPeriodicLoadsListRequest = () => ({
    type: actionTypes.OPENYOUNG_PERIODIC_LOADS_LIST_REQUEST
});

const getPeriodicLoadsListSuccess = (loadList) => ({
    type: actionTypes.OPENYOUNG_PERIODIC_LOADS_LIST_SUCCESS,
    payload: {
        loadList
    }
});

const getPeriodicLoadsListError = (error) => ({
    type: actionTypes.OPENYOUNG_PERIODIC_LOADS_LIST_ERROR,
    payload: {
        error
    }
});

const getPeriodicLoadsList = (immCard) => (dispatch, getState) => {
    const immFilters = getState().cardPeriodicLoads.get('filters');
    const amountFilter = immFilters.get('amount');
    const periodicityFilter = immFilters.get('periodicity');
    const requestData = {
        query: {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.getIn(['interventionList', 0, 'pan']),
            product: immCard.getIn(['contract', 'product']),
            searchFilter: {
                maxAmount: PERIODIC_LOADS_MAX_AMOUNT_DEFAULT,
                minAmount: PERIODIC_LOADS_MIN_AMOUNT_DEFAULT,
                periodicity: null
            }
        }
    };

    if(amountFilter.get('isActive')) {
        requestData.query.searchFilter.maxAmount = amountFilter.get('maxAmount')
            || PERIODIC_LOADS_MAX_AMOUNT_DEFAULT;
        requestData.query.searchFilter.minAmount = amountFilter.get('minAmount')
            || PERIODIC_LOADS_MIN_AMOUNT_DEFAULT;
    }
    if(periodicityFilter.get('isActive')) {
        requestData.query.searchFilter.periodicity = periodicityFilter.get('periodicity');
    }

    dispatch(getPeriodicLoadsListRequest());
    return APIPost({
        dispatch,
        endpoint:'cardPeriodicTransfersList',
        params: requestData
    })
    .then((response) => {
        dispatch(getPeriodicLoadsListSuccess(response.list));
    })
    .catch((response) => {
        if (!!response.error) {
            dispatch(getPeriodicLoadsListError(response.error.description));
        } else {
            throw response;
        }
    });
}

const deletePeriodicLoadRequest = () => ({
    type: actionTypes.DELETE_PERIODIC_LOAD_REQUEST,
});

const deletePeriodicLoadSuccess = () => ({
    type: actionTypes.DELETE_PERIODIC_LOAD_SUCCESS,
});

const deletePeriodicLoadError = (error) => ({
    type: actionTypes.DELETE_PERIODIC_LOAD_ERROR,
    payload: {
        error
    }
});

const deletePreiodicLoad = (periodicLoadData) => (dispatch) => {
    const requestData = {
        query: {
            contractNumber : periodicLoadData.get('contractNumber'),
            product: periodicLoadData.get('product'),
            scheduleTransferId: periodicLoadData.get('scheduleTransferId')
        }
    }

    dispatch(deletePeriodicLoadRequest());
    return APIPost({
        dispatch,
        endpoint:'deletePeriodicLoad',
        params: requestData
    })
    .then((response) => {
        dispatch(deletePeriodicLoadSuccess(response));
    })
    .catch((response) => {
        if (!!response.error) {
            dispatch(deletePeriodicLoadError(response.error.description));
        } else {
            throw response;
        }
    });
}

const applyOpenYoungPeriodicLoadsFilter = (filters) => ({
    type: actionTypes.OPENYOUNG_PERIODIC_LOADS_SET_FILTERS,
    payload: {
        filters
    }
});

const requestResetOpenYoungCardPeriodicLoadsFilter = (filterKey) => ({
    type: actionTypes.OPENYOUNG_PERIODIC_LOADS_RESET_FILTERS,
    payload: {
        filterKey
    }
});

const requestClearOpenYoungCardPeriodicLoadsFilter = () => ({
    type: actionTypes.OPENYOUNG_PERIODIC_LOADS_CLEAR_FILTERS
});

module.exports = {
    applyOpenYoungPeriodicLoadsFilter,
    deletePreiodicLoad,
    deletePeriodicLoadRequest,
    getPeriodicLoadsList,
    requestClearOpenYoungCardPeriodicLoadsFilter,
    requestResetOpenYoungCardPeriodicLoadsFilter
}
